import { AgentService } from "services/AgentService";

export const isSecondarySignedUp = async (email: string) => {
  const newAgent = new AgentService();
  const agents = await newAgent.getAgentByField("email", email);

  return agents[0]?.isSignedUp;
};
